// @ts-nocheck

import React, { useCallback, useMemo, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { Target } from '../../../../client';
import AppearTransitionGroup from '../../../../components/AppearTransitionGroup';
import ModalFooter from '../../../../components/ModalFooter';
import { __ } from '../../../../i18n/l10n';
import { WinamaxLogo } from '../../../../styled-components/shared';
import type { SetTutoStepType } from '../../types/actions';
import SwipeReperes from '../basket/SwipeReperes';
import Primary from '../buttons/Primary';
import Secondary from '../buttons/Secondary';

import Steps, { TUTO_NB_STEPS } from './Steps';

const Wrap = styled.div`
  color: #fff;
  padding: 1em;
  font-size: 0.9em;
  font-family: BettingPoliticaExtraBold, sans-serif;
`;

const WrapButtons = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-around;
  padding: 1em;
  background-color: ${({ theme }) => (Target.__MOBILE__ ? theme.grids.colors.black : theme.grids.colors.darkgrey3)};
`;

const WrapReperes = styled.div`
  padding: 0 1em 1em;
  background-color: ${({ theme }) => (Target.__MOBILE__ ? theme.grids.colors.black : theme.grids.colors.darkgrey3)};
`;

const common = css`
  && {
    width: 100%;
    margin: 0 0.2em;
  }
`;

const StyledPrimary = styled(Primary)`
  ${common}
`;

const StyledSecondary = styled(Secondary)`
  ${common}
`;

const StyledLogo = styled(WinamaxLogo)`
  top: 0.5em;
`;

type GridsTutoProps = {
  className?: string;
  step: number;
  setTutoStep: SetTutoStepType;
};

const GridsTuto = ({ className, step, setTutoStep }: GridsTutoProps) => {
  const history = useHistory();
  const location = useLocation();

  const close = useCallback(() => {
    history.push(location.pathname);
    setTutoStep(0);
  }, [history, location.pathname, setTutoStep]);

  const next = useCallback(() => {
    setTutoStep(step + 1);
  }, [setTutoStep, step]);

  const previous = useCallback(() => {
    setTutoStep(step - 1);
  }, [setTutoStep, step]);

  useEffect(() => {
    return () => {
      // if we close at last step, reset
      if (step === TUTO_NB_STEPS - 1) {
        setTutoStep(0);
      }
    };
  }, [setTutoStep, step]);

  const renderFooter = useCallback(
    () => (
      <>
        <WrapButtons>
          {step > 0 && step !== TUTO_NB_STEPS - 1 && (
            <StyledSecondary onClick={previous}>{__('Previous')}</StyledSecondary>
          )}
          {step < TUTO_NB_STEPS - 1 ? <StyledPrimary onClick={next}>{__('Next')}</StyledPrimary> : null}
          {step === TUTO_NB_STEPS - 1 ? <StyledPrimary onClick={close}>{__('Get started')}</StyledPrimary> : null}
        </WrapButtons>
        <WrapReperes>{step !== 0 && <SwipeReperes isRed current={step} length={TUTO_NB_STEPS} />}</WrapReperes>
      </>
    ),
    [close, next, previous, step],
  );

  const Component = useMemo(() => Steps[step], [step]);

  return (
    <Wrap className={className}>
      {!Target.__MOBILE__ && <StyledLogo />}
      <AppearTransitionGroup uniqKey={step}>
        <div>
          <Component />
        </div>
      </AppearTransitionGroup>
      <ModalFooter render={renderFooter} />
    </Wrap>
  );
};

export default GridsTuto;
